var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',[_c('ck-header-background'),_c('ck-header',{on:{"logout":_vm.logout,"gotoaccount":_vm.account}}),_c('ck-blog-post-content'),_c('ck-footer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }